import {getFormattedRoundedDate} from "../../../CommonFunctions";
import React, {useEffect, useState} from "react";
import {useGetData} from "../../../../api/useFetch";
import {maintenancePath} from "../../../../api/apiMaintenance";
import {Loading} from "../../../common/Loading";

export const MaintenancesHistoryTable = (props) => {

    const {cellId, structureId, isInMaintenance} = props;
    let maintenancesHistoryParams = cellId ? {farmStructure: structureId, farmCell: cellId} : {farmStructure: structureId};

    const maintenancesHistory = useGetData('farm maintenances', maintenancePath + '/history', maintenancesHistoryParams);

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if(cellId && maintenancesHistory.data)
            maintenancesHistory.refetch().then(() => setIsLoading(false));
        else
            setIsLoading(false);
    }, [isInMaintenance]);

    const getMaintenanceUser = (user) => {
        return user ? user.firstname + ' ' + user.lastname : '--';
    }

    if(maintenancesHistory.isLoading || isLoading) return <Loading/>;

    return(
        <div className="farm__dialog_maintenance_history">
            <div className="maintenances-history-title">Historique des maintenances</div>
            <div className="maintenances-history-body">
                {maintenancesHistory.data && maintenancesHistory.data.length > 0 ?
                    <div className="maintenances-history-table">
                        <table>
                            <thead>
                            <tr>
                                <th>Date de démarrage</th>
                                <th>Date de fin</th>
                                <th>Utilisateur</th>
                                {cellId &&
                                    <th>Maintenance générale</th>
                                }
                            </tr>
                            </thead>
                            <tbody>
                            {maintenancesHistory.data.map(maintenance =>
                                <tr key={maintenance.id}>
                                    <td>{getFormattedRoundedDate(new Date(maintenance.start_date)).toString()}</td>
                                    <td>{maintenance.end_date ? getFormattedRoundedDate(new Date(maintenance.end_date)).toString() : '--'}</td>
                                    <td>{getMaintenanceUser(maintenance.user)}</td>
                                    {cellId &&
                                        <td>{maintenance.farm_structure ? 'Oui' : 'Non'}</td>
                                    }
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div> :
                    <div>Aucun historique de maintenance</div>
                }
            </div>
        </div>
    );
}